import { useResetPassword } from '../hooks/useResetPassword'
import { PASSWORD_REQUIREMENT_MESSAGE } from '@common/utils/password-validator'

function ResetPasswordForm() {
  const {
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    showNewPassword,
    showConfirmPassword,
    isLoading,
    newPasswordError,
    confirmPasswordError,
    setNewPasswordError,
    setConfirmPasswordError,
    handleSubmit,
    toggleNewPasswordVisibility,
    toggleConfirmPasswordVisibility,
  } = useResetPassword()

  return (
    <form onSubmit={handleSubmit}>
      <div className={`form-group ${newPasswordError ? 'has-error' : ''}`}>
        <label htmlFor="newPassword">新しいパスワード</label>
        <div className="password-input-wrapper">
          <input
            id="newPassword"
            type={showNewPassword ? 'text' : 'password'}
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value)
              if (newPasswordError) setNewPasswordError(null)
            }}
            placeholder="6文字以上の半角小文字英字・数字"
            autoComplete="new-password"
            className={newPasswordError ? 'error' : ''}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={toggleNewPasswordVisibility}
            aria-label={showNewPassword ? 'パスワードを隠す' : 'パスワードを表示'}
          >
            <i className={showNewPassword ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
          </button>
        </div>
        {newPasswordError && (
          <div className="field-error">
            <i className="bi bi-exclamation-circle"></i>
            <span>{newPasswordError}</span>
          </div>
        )}
        <p className="password-requirement-text">
          {PASSWORD_REQUIREMENT_MESSAGE}
        </p>
      </div>

      <div className={`form-group ${confirmPasswordError ? 'has-error' : ''}`}>
        <label htmlFor="confirmPassword">新しいパスワード（再入力）</label>
        <div className="password-input-wrapper">
          <input
            id="confirmPassword"
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value)
              if (confirmPasswordError) setConfirmPasswordError(null)
            }}
            placeholder="新しいパスワード（再入力）"
            autoComplete="new-password"
            className={confirmPasswordError ? 'error' : ''}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={toggleConfirmPasswordVisibility}
            aria-label={showConfirmPassword ? 'パスワードを隠す' : 'パスワードを表示'}
          >
            <i className={showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
          </button>
        </div>
        {confirmPasswordError && (
          <div className="field-error">
            <i className="bi bi-exclamation-circle"></i>
            <span>{confirmPasswordError}</span>
          </div>
        )}
      </div>

      <button type="submit" className="login-button" disabled={isLoading}>
        {isLoading ? '変更中...' : 'パスワードを変更'}
      </button>
    </form>
  )
}

export default ResetPasswordForm
